/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.model.patient

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CreatePatientRequest(
    val name: String,
    val phone: String,
    val email: String? = null,
    @SerialName("default_fee") val defaultFee: Long,
    val notes: String? = null,
    @SerialName("reminders_paused") val remindersPaused: Boolean = false,
)
